import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { type InboundFilterState, filterToQuery } from "../lib/inbound-filter";

import { inboundKeys } from "./query-keys";

export function useListInbound(filter: InboundFilterState) {
  return useQuery({
    queryKey: inboundKeys.list(filter),
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/reports/inbound", {
        params: { query: filterToQuery(filter) },
      });
      if (error) throw error;
      return data;
    },
    staleTime: 30_000,
  });
}
